import audits from 'pages/audits'

export default [
  //Reports
  { path: '/audits', name: 'audits.all', component: audits
    , meta:{permits:[]}},
]
